import type { AlertGroup } from '@d-orca/shared/alert-kinds';
import { ActivityIcon, ChartColumnIcon, IssuesIcon, ShieldIcon } from '@utils/icons';
import styles from './AlertVisual.module.css';

const ICON_BY_GROUP = {
  safety: ShieldIcon,
  reports: ChartColumnIcon,
  activities: ActivityIcon,
  issues: IssuesIcon,
} satisfies Record<AlertGroup, unknown>;

/** What stands in front of an alert: its group's icon, safety in red. */
export function AlertVisual({ group }: { group: AlertGroup }) {
  const Icon = ICON_BY_GROUP[group];
  return (
    <span className={`${styles.icon} ${group === 'safety' ? styles.safety : ''}`} aria-hidden="true">
      <Icon size={14} />
    </span>
  );
}
